import { render } from "./ForgotPasswordSuccessPage.vue?vue&type=template&id=545a4dab&ts=true"
import script from "./ForgotPasswordSuccessPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordSuccessPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__